  if (!customElements.get('fittem-review-empty-state')) {
    customElements.define('fittem-review-empty-state', class extends HTMLElement {
      connectedCallback() {
        this.productId = this.dataset.productId;
        if (!/^\d+$/.test(this.productId || '')) return;
        this.widgets = new Map();
        this.discoveryAttempts = 0;
        this.discoverWidgets();
      }

      disconnectedCallback() {
        clearTimeout(this.discoveryTimer);
        this.widgets?.forEach((observer) => observer.disconnect());
        this.widgets?.clear();
      }

      discoverWidgets() {
        if (!this.isConnected) return;
        const selector = `.klaviyo-star-rating-widget[data-id="${this.productId}"], [id="fulfilled-reviews-all"][data-id="${this.productId}"]`;
        document.querySelectorAll(selector).forEach((widget) => {
          if (this.widgets.has(widget)) return;
          const observer = new MutationObserver(() => this.updateWidget(widget));
          this.widgets.set(widget, observer);
          this.updateWidget(widget);
          observer.observe(widget, { childList: true, characterData: true, subtree: true });
        });
        this.discoveryAttempts += 1;
        if (this.widgets.size < 2 && this.discoveryAttempts < 20) {
          this.discoveryTimer = setTimeout(() => this.discoverWidgets(), 500);
        }
      }

      updateWidget(widget) {
        const isStarWidget = widget.classList.contains('klaviyo-star-rating-widget');
        const countSelector = isStarWidget
          ? '.kl_reviews__star_rating_widget__label'
          : '.kl_reviews__summary__stars__count';
        const countText = widget.querySelector(countSelector)?.textContent.trim() || '';
        const isEmpty = /^0\s+reviews?$/i.test(countText);
        widget.classList.toggle('fittem-reviews-empty', isEmpty);
        if (isStarWidget) return;

        const summary = widget.querySelector('.kl_reviews__summary');
        if (!summary) return;
        let invitation = summary.querySelector('.fittem-review-invitation');
        if (isEmpty && !invitation && this.dataset.emptyText) {
          invitation = document.createElement('p');
          invitation.className = 'fittem-review-invitation';
          invitation.textContent = this.dataset.emptyText;
          summary.append(invitation);
        }
        if (invitation) invitation.hidden = !isEmpty;
      }
    });
  }
